export enum RouteName {
  Reservations = "Reservations",
  Dashboard = "Dashboard",
  DashboardExecutive = "ExecutiveDashboard",
  Resources = "Resources",
  ResourceDetail = "ResourceDetail",
  Events = "Events",
  EventDetail = "EventDetail",
  EventDetailEdit = "EventDetailEdit",
  Occupation = "Occupation",
  Users = "Users",
  audit = "audit",
  EventType = "EventType",
}
